import axios from 'axios';
import {
  API_URL,
  INSPECTORS,
  UPDATE_INSPECTOR,
  SHOW_INSPECTOR,
  DELETE_INSPECTOR_PASS,
  CREATE_INSPECTOR,
  RESTORE_INSPECTOR,
  SHOW_COMPANY_INSPECTOR, SHOW_RIGHTSHIP_REPORT, GET_RIGHTSHIP_CHART_DATA
} from './ConstantService';

export const InspectorsService = {
  getAll(params = {}) {
    return axios.get(INSPECTORS, { params });
  },

  show(id) {
    return axios.get(SHOW_INSPECTOR.replace('{id}', id));
  },

  showCompanyInspectors(id){
    return axios.get(SHOW_COMPANY_INSPECTOR.replace('{id}', id));
  },

  // showRightshipReport(data){
  //   return axios.post(SHOW_RIGHTSHIP_REPORT, data);
  // },

  showRightshipReport(params = {}) {
    return axios.post(SHOW_RIGHTSHIP_REPORT, { params });
  },

  getRsInspectorCharts(params = {}){
    return axios.post(GET_RIGHTSHIP_CHART_DATA, { params });
  },

  create(data) {
    return axios.post(CREATE_INSPECTOR, data);
  },

  update(id, data) {
    return axios.patch(UPDATE_INSPECTOR.replace('{id}', id), data);
  },

  // delete(id) {
  //   return axios.delete(DELETE_INSPECTOR.replace('{id}', id));
  // },

  deleteWithPassword(id, password) {
    return axios.post(DELETE_INSPECTOR_PASS.replace('{id}', id), { password });
  },

  restore(id) {
    return axios.post(RESTORE_INSPECTOR.replace('{id}', id));
  }
};
